export default {
	getItem: state => (id) => {
		return state.items.find((item) => item.id === id)
	},
	getItems: state => state.items,
	getNextPage: state => {
        return state.next_page_index
    },
	getLengthRecord: state => {
        return state.length_record
    },
	getStartRecord: state => {
		return state.start_record
	},
	getDefaultMarketId: state => {
        return state.default_market_id
	},
	getTotalRecord: state => {
		return state.total_record
	},
	getIsCashFilter: state => {
		return state.is_cash_scanner
	},
	getFxspotCurrencyList: state => {
		return state.fxspot_currency_list
	},
	getCashSymbols: state => {
		return state.cash_symbols
	},
}